import { createSlice } from '@reduxjs/toolkit';
import { FETCH_SEARCH_RESULTS } from '../../../actions-index';
import { ERROR_CONSTS } from '../../../util/constants';

// ---------------------------------------------------------------------------
// navbarSearchReducer slice
// ---------------------------------------------------------------------------
const searchInitialState = {
  status: '',
  alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
  data: [],
};

const navbarSearchSlice = createSlice({
  name: 'navbarSearchReducer',
  initialState: {
    searchResults: { ...searchInitialState, type: FETCH_SEARCH_RESULTS },
    searchValue: null,
  },
  reducers: {
    fetchSearchResults(state, action) {
      state.searchResults = {
        status: action.payload.status,
        alert: action.payload.alert,
        data: action.payload.data ?? [],
        type: FETCH_SEARCH_RESULTS,
      };
    },
    setSearchValue(state, action) {
      Object.assign(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(FETCH_SEARCH_RESULTS, (state, action) => {
      state.searchResults = {
        status: action.payload.status,
        alert: action.payload.alert,
        data: action.payload.data ?? state.searchResults?.data ?? [],
        type: FETCH_SEARCH_RESULTS,
      };
    });
  },
});

export const { fetchSearchResults, setSearchValue } = navbarSearchSlice.actions;
export const navbarSearchReducer = navbarSearchSlice.reducer;
